export enum WorkFocusedPlanTypeformFieldRef {
  Fatigue = 's_fatigue',
}
